export default __webpack_public_path__ + "static/media/notpay3month.ba20d922.svg";